import KeyboardArrowDownRounded from '@mui/icons-material/KeyboardArrowDownRounded'
import { get, omit } from 'lodash'
import React from 'react'

import StyledTextField from './StyledTextField'
import WithInputLabel from './WithInputLabel'

import type { TextFieldProps } from '@mui/material/TextField'

const WithInputLabelTyped = WithInputLabel as React.FC<{
  children: React.ReactNode
  label?: string
  required?: boolean
  endIcon?: React.ReactNode
  error?: string
  disabled?: boolean
}>

type HHTextFieldProps = Omit<TextFieldProps, 'error' | 'variant'> & {
  label?: string
  endIcon?: React.ReactNode
  error?: string
  readOnly?: boolean
  deprecatedLabel?: boolean
  variant?: 'filled' | 'outlined' | 'standard'
}

const HHTextField: React.FC<HHTextFieldProps> = ({
  label,
  disabled,
  required,
  endIcon,
  variant = 'outlined',
  error = '',
  readOnly = false,
  InputProps = {},
  SelectProps = {},
  deprecatedLabel = true,
  ...rest
}) => {
  const helperText = rest?.helperText
  const MenuProps = get(SelectProps, 'MenuProps', {})
  const MenuSx = get(MenuProps, 'sx', {})
  const PaperProps = get(MenuProps, 'PaperProps', {})
  const PaperSx = get(PaperProps, 'sx', {})
  return (
    <WithInputLabelTyped
      disabled={disabled}
      endIcon={endIcon}
      error={error}
      label={deprecatedLabel ? label : undefined}
      required={required}
    >
      <StyledTextField
        disabled={disabled}
        InputProps={{ ...InputProps, readOnly }}
        label={deprecatedLabel ? null : label}
        variant={variant}
        {...rest}
        error={Boolean(error)}
        helperText={typeof error === 'string' && error ? error : helperText}
        SelectProps={{
          ...SelectProps,
          IconComponent: (props: object) => <KeyboardArrowDownRounded {...props} />,
          MenuProps: {
            ...MenuProps,
            sx: { ...MenuSx },
            elevation: 0,
            PaperProps: {
              sx: {
                // eslint-disable-next-line no-restricted-syntax -- pre-existing shadow; theme not available here
                boxShadow: '0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)',
                maxHeight: 400,
                ...PaperSx,
              },
              variant: 'outlined',
              ...omit(PaperProps, ['sx']),
            },
          },
        }}
      />
    </WithInputLabelTyped>
  )
}

export default HHTextField
